import React from 'react'
import { Accordion } from 'react-bootstrap'

const AccordionItems = ({ eventKey, itemClassName = "", headerClassName = "", bodyClassName = "", titleName = "", children }) => {
    return (
        <Accordion.Item
            eventKey={eventKey}
            className={`mb-4 border-0 border-bottom ${itemClassName} `}
        >
            <Accordion.Header
                className={`activity-pricing-item ${headerClassName}`}
            >
                {titleName}
            </Accordion.Header>
            <Accordion.Body
                className={`${bodyClassName}`}
            >
                {children}
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default AccordionItems